import { Backdrop, Box, CircularProgress, Typography } from "@mui/material";

interface FullPageLoaderProps {
  open: boolean;
  message?: string;
}

export default function FullPageLoader({
  open,
  message = "Please wait...",
}: FullPageLoaderProps) {
  return (
    <Backdrop
      open={open}
      sx={{
        zIndex: (theme) => theme.zIndex.modal + 1,
        color: "#fff",
        flexDirection: "column",
        gap: 2,
        backdropFilter: "blur(4px)",
        backgroundColor: "rgba(0, 0, 0, 0.55)",
      }}
    >
      <CircularProgress
        size={56}
        thickness={4}
        sx={{
          color: "#fff",
          "& .MuiCircularProgress-circle": {
            strokeLinecap: "round",
          },
        }}
      />
      <Box sx={{ textAlign: "center" }}>
        <Typography
          variant="subtitle1"
          fontWeight={600}
          sx={{ letterSpacing: 0.5 }}
        >
          {message}
        </Typography>
      </Box>
    </Backdrop>
  );
}
